(function(){
  function initGallery(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    var main=root.querySelector('[data-tr-gallery-main]');
    root.querySelectorAll('[data-tr-gallery-thumb]').forEach(function(button){
      button.addEventListener('click',function(){
        main.src=button.dataset.src;main.srcset=button.dataset.srcset||'';main.alt=button.dataset.alt||'';
        root.querySelectorAll('[data-tr-gallery-thumb]').forEach(function(item){item.setAttribute('aria-current','false')});
        button.setAttribute('aria-current','true');main.focus({preventScroll:true});
      });
    });
  }
  function initSticky(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    var mainForm=document.querySelector('product-form form[id^="product-form-"]');
    var mainButton=mainForm&&mainForm.querySelector('[name="add"]');
    var stickyButton=root.querySelector('button');
    var price=root.querySelector('[data-tr-sticky-price]');
    var priceSource=document.querySelector('[id^="price-"]');
    if(!mainForm||!mainButton){root.hidden=true;return}
    function sync(){
      stickyButton.disabled=mainButton.disabled;
      stickyButton.textContent=mainButton.querySelector('span')?.textContent.trim()||mainButton.textContent.trim()||'Add to cart';
      if(price&&priceSource)price.innerHTML=priceSource.innerHTML;
    }
    stickyButton.addEventListener('click',function(){if(!stickyButton.disabled)mainForm.requestSubmit(mainButton)});
    new MutationObserver(sync).observe(mainButton,{subtree:true,attributes:true,childList:true,characterData:true});
    if(priceSource)new MutationObserver(sync).observe(priceSource,{subtree:true,childList:true,characterData:true});
    var observer=new IntersectionObserver(function(entries){root.classList.toggle('is-visible',!entries[0].isIntersecting)},{threshold:0});
    observer.observe(mainButton);sync();
  }
  function syncCartTriggerState(drawer){
    var expanded=drawer&&drawer.classList.contains('active');
    document.querySelectorAll('[data-cart-drawer-trigger]').forEach(function(trigger){
      trigger.setAttribute('aria-expanded',expanded?'true':'false');
    });
  }
  function observeCartDrawer(drawer){
    if(!drawer||drawer.dataset.trTriggerObserved)return;
    drawer.dataset.trTriggerObserved='true';
    new MutationObserver(function(){syncCartTriggerState(drawer)}).observe(drawer,{attributes:true,attributeFilter:['class']});
    syncCartTriggerState(drawer);
  }
  async function openCartDrawer(trigger){
    if(window.customElements&&customElements.whenDefined){
      await customElements.whenDefined('cart-drawer');
    }
    var drawer=document.querySelector('cart-drawer');
    var headerTrigger=document.querySelector('[data-cart-drawer-trigger]');
    var actualTrigger=trigger&&trigger.matches('[data-cart-drawer-trigger]')?trigger:headerTrigger||trigger;
    if(!drawer||typeof drawer.open!=='function'){
      console.error('[Trundes Cart] Cart drawer is unavailable.');
      return false;
    }
    drawer.open(actualTrigger||null);
    if(actualTrigger)actualTrigger.setAttribute('aria-expanded','true');
    observeCartDrawer(drawer);
    return true;
  }
  function isCartAnchor(element){
    if(!element||element.tagName!=='A')return false;
    try{
      var targetUrl=new URL(element.href,window.location.origin);
      return targetUrl.origin===window.location.origin&&targetUrl.pathname.replace(/\/+$/,'')==='/cart';
    }catch(error){
      return false;
    }
  }
  function installCartTriggerProtection(){
    if(window.__trundesCartTriggerInstalled)return;
    window.__trundesCartTriggerInstalled=true;
    document.addEventListener('click',function(event){
      if(!(event.target instanceof Element))return;
      var closeTrigger=event.target.closest('[data-cart-drawer-close]');
      if(closeTrigger){
        event.preventDefault();
        event.stopPropagation();
        var activeDrawer=closeTrigger.closest('cart-drawer')||document.querySelector('cart-drawer');
        if(activeDrawer&&typeof activeDrawer.close==='function')activeDrawer.close();
        return;
      }
      var trigger=event.target.closest('[data-cart-drawer-trigger],a[href]');
      if(!trigger)return;
      var isDrawerTrigger=trigger.matches('[data-cart-drawer-trigger]');
      if(!isDrawerTrigger&&!isCartAnchor(trigger))return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openCartDrawer(isDrawerTrigger?trigger:null);
    },true);
  }
  function init(scope){
    (scope||document).querySelectorAll('[data-tr-gallery]').forEach(initGallery);
    (scope||document).querySelectorAll('[data-tr-sticky-atc]').forEach(initSticky);
    observeCartDrawer(document.querySelector('cart-drawer'));
  }
  installCartTriggerProtection();
  document.addEventListener('DOMContentLoaded',function(){init(document)});
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();
